import type { ReactNode } from 'react';
import { Check, Trash2, X } from 'lucide-react';
import { useT } from '../i18n';
import { Modal } from './Modal';

interface ConfirmDialogProps {
  title: string;
  message: ReactNode;
  confirmLabel: string;
  confirmDisabled?: boolean;
  danger?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/** Obecný potvrzovací modal — zobecnění opakovaného vzoru (`ProjectListPage`, `HistoryPanel`). */
export function ConfirmDialog({
  title,
  message,
  confirmLabel,
  confirmDisabled,
  danger,
  onCancel,
  onConfirm,
}: ConfirmDialogProps) {
  const t = useT();
  return (
    <Modal
      title={title}
      onClose={onCancel}
      actions={
        <>
          <button type="button" onClick={onCancel}>
            <X size={16} />
            {t('common.cancel')}
          </button>
          <button
            type="button"
            className={danger ? 'danger' : 'primary'}
            disabled={confirmDisabled}
            onClick={onConfirm}
          >
            {danger ? <Trash2 size={16} /> : <Check size={16} />}
            {confirmLabel}
          </button>
        </>
      }
    >
      <div className="stack">{message}</div>
    </Modal>
  );
}
